import { render } from "./TalkToMyDataInvocationsAdmin.vue?vue&type=template&id=1081b15d&scoped=true"
import script from "./TalkToMyDataInvocationsAdmin.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocationsAdmin.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocationsAdmin.vue?vue&type=style&index=0&id=1081b15d&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081b15d"]])

export default __exports__